function vcSignalTopology() {
    /// <summary>
    /// This object is the main entry point for  the three Topology class types<br/>
    /// this is the simplest form of those three and shows the signal dependencies to the customers
    /// Author: MWI<br />
    /// Date: 26.01.2016<br />
    /// Copyright ©: EUDT GmbH 2016 <br />
    /// Version-History:<br />
  /// **********************************************************************<br />
    /// *** v1.0.8 (MWI) - 12.12.2018                                              *<br />
    /// **********************************************************************<br />
    /// * - better centering                                                 *<br />
    /// **********************************************************************<br />
    /// **********************************************************************<br />
    /// *** v1.0.7 - 29.11.2017                                              *<br />
    /// **********************************************************************<br />
    /// * - fixed bug with IE 9                                              *<br />
    /// **********************************************************************<br />
    /// **********************************************************************<br />
    /// *** v1.0.6 - 12.9.2017                                              *<br />
    /// **********************************************************************<br />
    /// * - added the new tag filter and expanded it to the unassigned signals      *<br />
    /// **********************************************************************<br />
    /// *** v1.0.5 - 16.3.2017                                              *<br />
    /// **********************************************************************<br />
    /// * - fixed IE slider bug and added reset to center button             *<br />
    /// **********************************************************************<br />
    /// *** v1.0.4 - 1.3.2017                                              *<br />
    /// **********************************************************************<br />
    /// * - added slider for zoom                                            *<br />
    /// **********************************************************************<br />
    /// *** v1.0.3 - 13.10.2016                                                *<br />
    /// **********************************************************************<br />
    /// * - height of tabs in unitManager set to 1600px                      *<br />
    /// **********************************************************************<br />
    /// *** v1.0.2 - 10.03.2016                                                *<br />
    /// **********************************************************************<br />
    /// * - fixed bug with price unit not showing in name                    *<br />
    /// **********************************************************************<br />
    /// *** v1.0.1 - 22.02.2016                                                *<br />
    /// **********************************************************************<br />
    /// * - fixed bug with help dialog being to small                         *<br />
    /// * - dialog is called via doEvent                                      *<br/>
    /// **********************************************************************<br />
    /// *** v1.0.0 - 26.01.2016                                                *<br />
    /// **********************************************************************<br />
    /// * -  inherited from vcTopology js                                    *<br />
    /// * -  changed the complete structure and splitted it                  *<br />
    /// * -  forgot the first changelogs                                      *<br />
    /// * -  addded changelog and some missing comments and two translations * <br/>
    /// * - base code largely from http://bl.ocks.org/robschmuecker/7880033   *<br/>
    /// **********************************************************************<br />
    /// </summary>
    try {
        //object freeze fixes the object so it cannot be overriden during runtime
        this.ENUM_CHILD_STATUS = Object.freeze({ NONE: 1,HIDDEN: 2,SHOWN: 4,SPECIAL_NONE: 8,SPECIAL_HIDDEN: 16,SPECIAL_SHOWN: 32,SPECIAL_FIRST_TIME: 64});
        this.ENUM_NODE_STATUS = Object.freeze({SHOWN: 1,HIDDEN: 2});
    } catch (ex) {
        this.ENUM_CHILD_STATUS = {NONE: 1,HIDDEN: 2,SHOWN: 4,SPECIAL_NONE: 8,SPECIAL_HIDDEN: 16,SPECIAL_SHOWN: 32,SPECIAL_FIRST_TIME: 64};
        this.ENUM_NODE_STATUS = {SHOWN: 1,HIDDEN: 2};
    }

    /**Build the Settings object ***/
    this.settings = {
        standardelement: '#divTreeWidget',
        viewerHeight: 950,
        viewerWidth: 925,
        data: {completeTree: JSON.stringify({name: "Start", signalid: "-1",id: "-1_-1",count: "-1",children: []}),unassigned: {}},
        bsagid: -1,
        bluid: -1,
        isprice: false,
        resources: {legend: []},
        labelLengthMultiplicator: 12,
        levelHeight: 80,
        notAssignedHeight: 200,
        addclickhandler: null,
        ontreechanged: null
    };
    //variables defined with var are private
    // Calculate total nodes, max label length
    this.totalNodes = 0;
    this.maxLabelLength = 0;
    // variables for drag/drop
    this.selectedNode = null;
    this.draggingNode = null;
    this.dragStarted = false;
    this.domNode = null;
    this.relCoords = null;
    this.panTimer = false;
    this.nodes = null;
    this.links = null;
    // panning variables
    this.panSpeed = 800;
    this.panBoundary = 15; // Within 15px from edges will pan when dragging.
    this.duration = 750;
    // define a d3 diagonal projection for use by the node paths later on.
    this.diagonal = window.d3.svg.diagonal().projection(function (d) {
            return [d.y, d.x];
    });
    this.visual = $(".Topo");

    this.nodeWidth = 400;

    //#endregion VARIABLES DECLARATION
}
vcSignalTopology.prototype = new window.vcTemplate();
vcSignalTopology.prototype.updateNode = function () {
    ///<summary>
    ///empty function body to allow the Subclasses to make changes to the nodes
    ///</summary>
};
vcSignalTopology.prototype.updateLink = function () {
    ///<summary>
    ///empty function body to allow the Subclasses to make changes to the links
    ///</summary>
};
vcSignalTopology.prototype.updateTree = function(source, bSetSource) {
    ///<summary>
    /// functions that does most of the magic concernign the tree < br/>
    /// it starts by doing preparations for width/height, length of labels and such <br/>
    /// and goes on by subsquently adding the styled elements
    ///</summary>
    ///<param name="source" type="jsObjects">the source of the (sub)tree</param>
    ///<param name="bSetSource" type="boolean">whether to set this element as total root or not</param>
    var me = this;
    try {

        if (bSetSource) {
            me.root = source;
        }
        
        var levelWidth = [1];
        var childCount = function mchildCount(level, n) {

            if (n.children && n.children.length > 0) {

                if (levelWidth.length <= level + 1)
                    levelWidth.push(0);

                levelWidth[level + 1] += n.children.length;
                n.children.forEach(function(d) {
                    childCount(level + 1, d);
                });
            }
        };
        childCount(0, me.root);
        //me.tree = me.tree.size([newHeight, $("#overlay").width()]);
        var temp = me.tree.nodes(me.root);
        me.nodes = temp.reverse(),
            me.links = me.tree.links(me.nodes);
        window.d3.selectAll(".additionalParentLink").remove();

        me.multiParents = [];
        me.nodes.forEach(function(d) {
            d.circleSize = 9;
            if (d.tempChildren && d.tempChildren.length >= 0) {
                d.children = d.tempChildren;
                d.tempChildren = [];
            }
            if (d.nodeStatus === undefined) {
                d.nodeStatus = me.ENUM_NODE_STATUS.SHOWN;
            }

            if (!d.childStatus) {
                d.childStatus = me.ENUM_CHILD_STATUS.NONE;
                if (d.children && d.children.length > 0)
                    me.setChildStatus(d, me.ENUM_CHILD_STATUS.SHOWN);
                else if (d._children && d._children.length > 0)
                    me.setChildStatus(d, me.ENUM_CHILD_STATUS.HIDDEN);
                else if (!d.children || !d._children)
                    me.setChildStatus(d, me.ENUM_CHILD_STATUS.NONE);
                if (d.specialChildren && d.specialChildren.length > 0 && Array.isArray(d.specialChildren))
                    me.setChildStatus(d, me.ENUM_CHILD_STATUS.SPECIAL_SHOWN);
                else if (d._specialChildren && d._specialChildren.length > 0 ||
                    typeof d.specialChildren === "string" && d.specialChildren !== "")
                    me.setChildStatus(d, me.ENUM_CHILD_STATUS.SPECIAL_HIDDEN);
                else if (d.specialChildren)
                    me.setChildStatus(d, me.ENUM_CHILD_STATUS.SPECIAL_NONE);
            }
        });
        if (me.width <= 1200) {
            me.settings.labelLengthMultiplicator = 5;
        }
        me.nodes.forEach(function(d) {
            if (me.hasChildStatus(d.childStatus, me.ENUM_CHILD_STATUS.SPECIAL_HIDDEN) &&
                typeof d.specialChildren === "string" &&
                d.specialChildren !== "") {

                var extraParameter = {};
                var temp = d.specialChildren.split(",");
                extraParameter.extraChildren = [];
                for (var extraCount = 0; extraCount <= temp.length - 1; extraCount++) {
                    var temp2 = temp[extraCount].split(":");
                    extraParameter.childArray = temp2;
                    me.visit(me.root, me.parseChildren, me.lookForChildren, extraParameter);
                }
                d.specialChildren = extraParameter.extraChildren;
                d._specialChildren = null;
                me.setChildStatus(d, me.ENUM_CHILD_STATUS.SPECIAL_SHOWN);
            }
            if (me.hasChildStatus(d.childStatus, me.ENUM_CHILD_STATUS.SPECIAL_HIDDEN) && d._specialChildren) {

                d.specialChildren = d._specialChildren;
                d._specialChildren = null;
                me.setChildStatus(d, me.ENUM_CHILD_STATUS.SPECIAL_SHOWN);
            }
            if (me.hasChildStatus(d.childStatus, me.ENUM_CHILD_STATUS.SPECIAL_SHOWN)) {
                var tempNode = null;
                var bTriggerChildren = false;
                for (var k = 0; k < d.specialChildren.length; k++) {
                    tempNode = d.specialChildren[k];
                    while (tempNode.parent &&
                        me.hasChildStatus(tempNode.parent.childStatus, me.ENUM_CHILD_STATUS.HIDDEN) &&
                        tempNode.parent.signalid !== "-1") {
                        tempNode = tempNode.parent;
                        bTriggerChildren = true;
                    }
                    if (d.specialChildren[k].parent) {

                        var multiPair = {
                            source: d,
                            target: d.specialChildren[k]
                            //target:
                        };

                        me.removeChildStatus(d, me.ENUM_CHILD_STATUS.SPECIAL_HIDDEN);
                        me.setChildStatus(d, me.ENUM_CHILD_STATUS.SPECIAL_SHOWN);
                        me.multiParents.push(multiPair);
                    }
                }
                if (bTriggerChildren && window.d3.event && window.d3.event.currentTarget.__data__.id === d.id)
                    me.updateTree(me.expand(tempNode), false);
            }
            d.y = d.depth * me.nodeWidth;
         
        });

        // Update the nodes…
        var node = me.svgGroup.selectAll("g.node").data(me.nodes,
            function(d) {
                return d.id;
            });
        // Enter any new nodes at the parent's previous position.                                                   
        var nodeEnter = node.enter().append("g").attr('data-bsagid',
            function(d) {
                return d.bsagid;
            }).attr('data-found', true).attr("id",
            function(d) {
                d.nodeStatus = me.ENUM_NODE_STATUS.SHOWN;
                return "node" + d.id;
            }).attr("class", me.setNodeClass);
        me.buildNode(nodeEnter);
        // Transition nodes to their new position.
        var nodeUpdate = node.transition().duration(me.duration).attr("transform", function(d) {  return "translate(" + (d.y - me.nodeWidth) + "," + (d.x) + ")"; });

        nodeUpdate.select("circle.nodeCircle").style("fill", function (d) {
            var ret = "#fff";
            if (me.hasChildStatus(d.childStatus, me.ENUM_CHILD_STATUS.HIDDEN)) {
                ret = "lightsteelblue";
            } else if (me.hasChildStatus(d.childStatus, me.ENUM_CHILD_STATUS.SPECIAL_HIDDEN)) {
                ret = "lightsteelblue";
            }
            return ret;
        });

        me.updateNode(nodeUpdate);
    
        // Transition exiting nodes to the parent's new position.
        var nodeExit = node.exit().transition().duration(me.duration).attr("transform", function (d) {
                d.nodeStatus = me.ENUM_NODE_STATUS.HIDDEN;
                return "translate(" + d.y + "," + d.x + ")";
            }).remove();
        nodeExit.select("circle").attr("r", 0);
        nodeExit.select("text.nodeText").style("fill-opacity", 0);
        $(nodeExit.select("tspan.nodeErr")).remove();


    
        //#endregion NODES EXITING
        // Update the links…
        var link = me.svgGroup.selectAll("path.link").data(me.links, function (d) {
                return d.target.id;
            });
        //add Extra Links to Simulate Multiple Parents
        // Enter any new links at the parent's previous position.
        link.enter().insert("path", "g").attr("id", function (d) {
            return "linkID" + d.source.id + "_" + d.target.id;
        }).attr("class", function (d) {
            try {
                if (d.source.signalid === "-1") {
                    return "link hidden";
                } else {
                    var linkClass = "link";
                    if (d.source.isGenerator === "True")
                        linkClass += " generator";
                    return linkClass;
                }
            } catch (ex) {
              
                me.writeError("vcSignalTopology.addPathClass", ex);
                return "";
            }
        }).attr("d", function (d) {
            try {
                var o = {
                    x: d.source.x,
                    y: d.source.y
                };
                return me.diagonal({
                    source: o,
                    target: o
                });
            } catch (ex) {
                
                me.writeError("vcSignalTopology.addPath", ex);
                return null;
            }
        });
        // Transition links to their new position.
        link.transition().duration(me.duration).attr("d", me.diagonal);
     

        // Transition exiting nodes to the parent's new position.
        link.exit().transition().duration(me.duration).attr("d", function (d) {
            try {
                var o = {
                    x: d.source.x,
                    y: d.source.y
                };
                return me.diagonal({
                    source: o,
                    target: o
                });
            } catch (ex) {
                me.writeError("vcSignalTopology.removePath", ex);
                return null;
            }
        }).remove();


        //if (me.settings.data.OnlyFirstLevel === false && me.nodes.length > 15) {
        //    console.info(me.svgGroup);


        //}



      
        // Stash the old positions for transition.
        me.nodes.forEach(function (d) {
            d.x0 = d.x ;
            d.y0 = d.y ;
        });



        me.multiParents.forEach(function (multiPair) {
            var linkClass = "link additionalParentLink";
            if (multiPair.source.isGenerator === "True")
                linkClass += " generator";
            me.svgGroup.insert("path", "g", ":first-child").attr("class", linkClass).attr("d", function () {
                //multiPair.target = window.d3.select("#node" + multiPair.target.id).data();
                var oTarget = {
                    x: multiPair.target.x0,
                    y: multiPair.target.y0,
                    id: multiPair.target.id
                };
                var oSource = {
                    x: multiPair.source.x0,
                    y: multiPair.source.y0,
                    id: multiPair.source.id
                };
                return me.diagonal({
                    source: oSource,
                    target: oTarget
                });
            }).datum(multiPair);
        });


        me.updateLink();
        me.setWarning();

                //window.setTimeout(me.setWarning(), 100);
        return true;
    } catch (ex) {
        me.error = true;
        me.writeError(me.source + '.JS.updateTree', ex);
        return false;
    }
};

vcSignalTopology.prototype.setWarning = function() {
    var me = this;
    try {
        $("#baseHeader").find(".note.err").remove();
        if ($(".nodeErr.err-visible").length > 0) {
            $("#baseHeader").append("<div class='note err'>" +
                me.settings.resources.dataInvalidSignalsFound +
                "</div>");
            //me.divRem.show();
        } else {
            me.showInfo("", "", false);

        }
    } catch (ex) {
        me.writeError('vcSignalTopology.setWarning', ex);
        return false;
    }
    return true;
};
vcSignalTopology.prototype.parseChildren = function (x, additionalPar) {
    var me = this;
    try {

        var tempCount;
        if (additionalPar.childArray[1] && additionalPar.childArray[1].indexOf(";") !== -1) {
            tempCount = additionalPar.childArray[1].substring(0, additionalPar.childArray[1].length - 1);
        } else {
            tempCount = additionalPar.childArray[1];
        }
        if (parseInt(x.signalid, 10) === parseInt(additionalPar.childArray[0], 10) && parseInt(x.count, 10) === parseInt(tempCount, 10)) {
            x.isSpecialChild = true;
            additionalPar.extraChildren.push(x);
        }
    } catch (ex) {
        me.writeError("parseChildren", ex);
    }
};

vcSignalTopology.prototype.lookForChildren = function (z, me) {
    try {

        //hasChildStatus(d.childStatus, me.ENUM_CHILD_STATUS.HIDDEN)
        if (me.hasChildStatus(z.childStatus, me.ENUM_CHILD_STATUS.SHOWN))
            return z.children;
        else if (me.hasChildStatus(z.childStatus, me.ENUM_CHILD_STATUS.HIDDEN))
            return z._children;
        else
            return null;
    } catch (ex) {
        me.writeError("lookForChildren", ex);
        return "";
    }
};
vcSignalTopology.prototype.init = function () {
    /// <summary>Initialization function preparing all common divs</summary>
    /// <returns type="boolean">true if the preparation is ok, false otherwise</returns>
    var me = this;
    try {
        if (me.error) {
            return false;
        }
        if (me.settings.data.OnlyFirstLevel === true) {
            me.settings.levelHeight = 40;
        }
        me.showInfo("", "", false);
        me.myData = JSON.parse(me.settings.data.completeTree);
        if (me.myData.children.length < 1 && !me.save) {

            me.showInfo(me.resources.noEntriesExist,"", false);
                        me.visual.find("#divTreeTop, #treeHolder, #start").hide();

            return true;
        } else {
            me.unassigned = me.settings.data.unassigned;

            //tree root
            me.root = typeof me.settings.data.completeTree === "string"
                ? JSON.parse(me.settings.data.completeTree)
                : me.settings.data.completeTree;
            me.root.x0 = me.settings.viewerHeight / 2;
            me.root.y0 = 0;
            me.legendHeight = 30;
            // define the zoomListener which calls the zoom function on the "zoom" event constrained within the scaleExtents
            me.zoomListener = window.d3.behavior.zoom().scaleExtent([me.settings.ZOOM_MIN_VAL,me.settings.ZOOM_MAX_VAL]).on("zoom",
                function() {
                    me.zoom(me);
                });
            // define the baseSvg, attaching a class for styling and the zoomListener
            me.divHolder = $("<div>").attr("id", "treeHolder");
            me.divHolder.appendTo(me.visual);

            me.dialog = $("<div>").attr("id", "infoDialog").css({ display: "none" });
            me.dialog.appendTo(me.divHolder);
            me.dialog.dialog({
                autoOpen: false,
                modal: true,
                resizable: false,
                dialogClass: "no-close topo-dialog",
                title: me.settings.resources.sigInfo,
                buttons: {
                    Ok: function Ok() {
                        $(this).dialog("close");
                    }
                }
            });
            me.divHolder.appendTo(me.visual);
            if (me.settings.data.OnlyFirstLevel === false) {
                 me.visual.find(".vc-filter").vcFilter({ callback: function () { me.filter(); } });
            } else {
                $("#divTreeTop").remove();
                me.divHolder.removeClass("vc-list-border").css({"height": "100%"});
            }
      
         
          me.visual.find("#btnReset")
                    .off("click")
                .on("click", function () {
                me.resetView(1);
            });
         
            me.settings.viewerHeight = me.settings.viewerHeight - me.legendHeight - 10 - me.settings.notAssignedHeight;


            me.visual.find("#divUnass .signalBox").off("click").on("click", function () {
                me.vcVisual.showSignalAnalogSummaryDialog($(this).dappendata("bsaid"));
            });

            //me.dragListener = window.d3.behavior.drag().on("dragstart", function () {
            //    me.dragStarted = true;
            //}).on("drag", function () {
            //        me.onDrag(me, this);
            //    });
            var eventString = "input";
            me.ieVersion = me.detectIE();
            if (me.ieVersion >= 10) {
                    eventString = "change";
            }
            if ((me.ieVersion >= 10 || me.ieVersion === -1) && me.settings.OnlyFirstLevel === false) {

                me.slider = me.visual.find("#slidezoom").on(eventString,

                    function () {
                        me.zoomListener.scale($(this).val()).event(me.svgGroup);
                    });
                me.visual.find("#zoom-up").off("click").on("click",
                    function () {
                        var newVal = parseFloat(me.slider.val()) + parseFloat(me.settings.ZOOM_STEP);
                        me.slider.val(newVal).trigger(eventString);
                    });


                me.visual.find("#zoom-down").off("click").on("click",
                    function () {
                        var newVal = parseFloat(me.slider.val()) - parseFloat(me.settings.ZOOM_STEP);
                        me.slider.val(newVal).trigger(eventString);
                    });


            } 
            //create a button to recenter the first node
            if (me.settings.OnlyFirstLevel === false) {
                me.btnRecenter = me.visual.find(".button-recenter");             
                me.btnRecenter.off("click").on("click",
                    function() {
                        //me.resetView(me.zoomListener.scale());
                        me.centerNode(me.root);
                    });
                //me.divTop.append(me.slidercontent);
            }
            me.prepareTree();
                    me.centerNode(me.root);

            return true;
        }
    } catch (ex) {
        me.error = true;
        me.writeError('init', ex);
        return false;
    }
};

vcSignalTopology.prototype.specificInfoHandling = function (bError) {
    /// <summary>
    /// This function can optionally overwriten by visual - can be used for specific tag showing/hiding and so on. 
    /// </summary>
    var me = this;
    try {
        if (bError) {           
            me.visual.find("#divTreeTop, #treeHolder, #start").hide();
        } else {
            me.visual.find("#divTreeTop, #treeHolder, #start").show();
        }
    } catch (ex) {
        me.writeError(me.source + ".JS." + "specificInfoHandling", ex);
    }
};
vcSignalTopology.prototype.resetView = function (scale) {
    ///<summary>
    ///this function tries to reset everything to normal and get the tree back into view<br/>
    ///</summary>
    var me = this;
    try {
        me.zoomListener.scale(scale);
        me.visit(me.root, function (child) {me.expand(me, child);}, me.lookForChildren, me);
        me.updateTree(me.root);
        me.centerNode(me.root);
    } catch (myEx) {
        me.writeError("btnResetFn", myEx);
    }
};
vcSignalTopology.prototype.addAdditionalButtons = function () {
    ///<summary>
    ///empty function to allow Subclasses to add some extra buttons <br/>
    ///e.g vcTopologyBuild (Dependency) the save button
    ///</summary>
};
vcSignalTopology.prototype.prepareTree = function () {
    ///<summary>
    ///This function prepares the common tree things <br/>v
    ///it creates the div and zoomListener
    ///</summary>
    var me = this;
    try {
        if (me.error) {
            return false;
        }
        me.baseSvg = window.d3.select("#" + me.divHolder.attr("id")).append("svg")
            .attr("width", "100%")
            .attr("height", "100%")
            .attr("x", 0)
            .attr("y", 3)
            .attr("class", "overlay")
            .attr("id", "overlay").call(me.zoomListener).on("dblclick.zoom", null).on("click", function () {
                if (me.dialog.dialog("isOpen"))
                    me.dialog.dialog("close");
            });

        me.addAdditionalButtons();

       // me.tree = window.d3.layout.tree().size([me.settings.viewerHeight, me.settings.viewerWidth - 5]);
        me.tree = window.d3.layout.tree().nodeSize([50, me.nodeWidth]);
        me.tree.separation = function(a, b) {
            return a.parent === b.parent ? 1 : 2;
        };
        // Append a group which holds all nodes and which the zoom Listener can act upon.
        me.svgGroup = me.baseSvg.append("g").attr('id', 'tree').attr("transform", "translate(" + 0 + "," + 0 + ")");

        me.updateTree(me.root, true);
        
        return true;
    } catch (ex) {
        me.error = true;
        me.writeError('prepareTree', ex);
        return false;
    }
};
vcSignalTopology.prototype.visit = function (parent, visitFn, childrenFn, additionalVisitPar) {
    /// <summary>A recursive helper function for performing some setup arbitrary by walking through all nodes</summary>
    /// <param name="parent" type="Node">The parent of the node to perform the setup for</param>
    /// <param name="visitFn" type="Function">the function that performs the actual setup on the node</param>
    /// <param name="childrenFn" type="Function">a function that returns the children of the node, could return also a subset of children</param>
    var me = this;
    var bRet  =true;
    try {
        if (parent) {
            if (additionalVisitPar)
                visitFn(parent, additionalVisitPar);
            else
                visitFn(parent, me);
            var children = childrenFn(parent, me);
            if (children) {
                var count = children.length;
                for (var i = 0; i < count && bRet; i++) {
                  bRet=  me.visit(children[i], visitFn, childrenFn, additionalVisitPar);
                }
            }
        }
        
    } catch (ex) {
        me.writeError('Topology.visit', ex);
        bRet = false;
    }
    return bRet;
};

vcSignalTopology.prototype.centerNode = function (source, bAdjustNodeToLeft) {
    ///<summary>this function tries to find a useable centering of any node <br/>
    /// it is only used for centering the root once
    ///</summary>
    var me = this;
    try {


        var scale = me.zoomListener.scale();
        var y = -source.x0;                 
        var add;

        var x = -source.y0;
        // add = (window.d3.select("#overlay").node().getBoundingClientRect().width - window.d3.select("#tree").node().getBoundingClientRect().width)/2;
        add = $("#treeHolder").width() / 2;
        if (source.id === "-1_-1" && me.source.indexOf("Dependency") === -1) {
                                                       add -= (me.nodeWidth + (me.nodeWidth / 2));
        } else if (me.source.indexOf("Dependency") === -1) {
            add -= (me.nodeWidth / 2);
        } else if (me.source.indexOf("Dependency") > -1) {
            add -= me.nodeWidth;
        }
      

       x = x*  scale  + add;

        var half = $("#treeHolder").height() / 2;
        y = y * scale + half;

        window.d3.select('g#tree').transition().duration(me.duration).attr("transform", "translate(" + x + "," + y + ")scale(" + scale + ")");
        me.zoomListener.scale(scale);
        me.zoomListener.translate([x, y]);
    
        return true;
    } catch (ex) {
        me.writeError('centerNode', ex);
        return false;
    }
};
vcSignalTopology.prototype.zoom = function (me) {
    /// <summary>Defines the zoom function the tree in window.d3</summary>
    try {
        me.svgGroup.attr("transform","translate(" + window.d3.event.translate + ")scale(" + window.d3.event.scale + ")");
        if (me.slider) {
            me.slider.val(window.d3.event.scale);
        }

    } catch (ex) {
        me.writeError("zoom", ex);
    }
};


vcSignalTopology.prototype.createHelp = function () {
    /// <summary>Helper function that creates the help div with legend</summary>
    var me = this;
    try {
        var sTmp = "";
        sTmp += "<div id='vid' width='670px'>";
        sTmp += "<div id='vidHelp'>";
        sTmp += "<ul id='legend'>";
        for (var k = 0; k < me.settings.resources.legend.length; k++) {
            sTmp += "<li>" + me.settings.resources.legend[k] + "</li>";
        }
        sTmp += "</ul></div>";
        sTmp += "<video width='640' height='391' controls='controls'><source src='../../images/tutorials/topology/help_scaled.mp4' type='video/mp4'>" + me.settings.resources.videoTagNotSupported_lbl + "</video>";
        sTmp += "</div>";
        return sTmp;
    } catch (ex) {
        me.writeError("createHelp", ex);
        return false;
    }
};



vcSignalTopology.prototype.TopoFilter = function(filterObj, listItem, classFound) {
    ///Overload Function of vcTemplateTagFilter for the Topology and Sankey
    var me = this;
    try {
        var filter = me.visual.find(filterObj).vcFilter("getFilter");

        me.visual.find(listItem).removeClass("found");
        me.visual.find(listItem).data('found-counter', 0);
        if (filter !== null) {
            var counter;
            //first, we count how often we find the filter tags in every signal item
            for (var i = 0; i <= filter.length - 1; i++) {
                if (filter[i].length > 0) {
                    me.visual.find(listItem + ":contains('" + filter[i] + "')")
                        .each(function() {
                            counter = parseInt($(this).data("found-counter"), 10);
                            if (isNaN(counter)) {
                                counter = 0;
                            }
                            counter++;
                            $(this).data("found-counter", counter);
                        });
                }
            }
            //if we found them as often as the number of filter tags - we are the lucky winner and show the entry!!
            //why? if we have several filter tags we have to find all of them in one single signal 
            me.visual.find(listItem)
                .each(function() {
                    if (parseInt($(this).data("found-counter"), 10) === filter.length) {
                        $(this).addClass(classFound);
                    }
                });
        }
    } catch (ex) {
        me.writeError("vcSignalTopology.setTagFilter", ex);
    }

};
vcSignalTopology.prototype.filter = function () {
    /// <summary>
    /// This function adds/removes two css-classes ('found' and 'exclude') for filtering loggers.<br/>
    /// When a logger with a filter expression gets found the 'found' class gets added - and the other way round for the 'exclude' class. <br/>
    /// At the end, basically all 'found' classes get shown and all 'exclude' classes get hidden - the favorites state gets considered as well.<br/>
    /// </summary>
    var me = this;
    try {
        me.visual.find("#divUnass .signalBox").hide();

        me.TopoFilter("#vc-topo-filter", ".node", "found");
        //me.setTagFilter();
        //get a list of filter expressions
        $(".node").not(".nA").each(function() {
            $(this).css({
                "opacity": 0.4
            });
            $(this).find(".nodeText").css({
                "font-weight": "normal",
                "font-size": "1em"
            });
        });
        $(".node").not(".nA").each(function () {
            //$(this).attr('data-found') === "true"
            if ($("#vc-topo-filter .vc-filter-input").val().trim().length === 0 && $(this).hasClass("found") === false) {
                $(this).css({
                    "opacity": 1
                });
                $(this).find(".nodeText").css({
                    "font-weight": "normal",
                    "font-size": "1em"
                });
            } else if ($(this).hasClass("found") === true) {
                $(this).css({
                    "opacity": 1
                });
                $(this).find(".nodeText").css({
                    "font-weight": "bold",
                    "font-size": "1.2em"
                });
            }
        });
        //$("#signallist li").not(".found").hide();
        //$("#signallist li.found").show();
        return true;
    } catch (ex) {
        me.writeError("topoFilter", ex);

        return false;
    }
};

vcSignalTopology.prototype.setFullScreen = function (isNormalScreen) {
    /// <summary>
    ///function to call the fullscreen of the sankey <br/>
    ///toggles diverse div's in its visibility to achieve the fullscreen
    ///</summary>
    var me = this;
    try {
        
        window.$("#header").toggle(isNormalScreen);
        window.$("#footer").toggle(isNormalScreen);
        if (isNormalScreen === false) {
            window.setMainContentHeight($("#divContent"), $("#container"), 0, 750, false);
            $("#divRamp1").height($("#divContent").height() - 190);
            $("#container").find(".Topo").height($("#divContent").height() - 190);
            $("#start").height($("#divContent").height() - 190);
        } else {
            var h = parseInt($("#header").height() + $("#footer").height() + 25);
            window.setMainContentHeight($("#divContent"), $("#container"), h, 750, false);
            $("#divRamp1").height($("#container").height() - 190);
            $("#container").find(".Topo").height($("#container").height() - 190);
            $("#start").height($("#container").height() - 190);
        }
        me.isNormalScreen = isNormalScreen;
        return true;
    } catch (ex) {
        me.writeError('setFullScreen', ex);
        return false;
    }
};
vcSignalTopology.prototype.hasChildStatus = function (nodeChildStatus, checkStatus) {
    /// <summary>Checks whether a given node has a certain child status <br/>
    ///  by making an AND connection and a is equal check</summary>
    /// <param name="nodeChildStatus" type="Integer">The childstatus of the given node as combined integer</param>
    /// <param name="checkStatuss" type="ENUM.CHILD_STATUS">The childstatus to check for taken from the prepared enum</param>
    /// <returns type="boolean">True if it has this child status</returns>
    /*jslint bitwise: true */
    var me = this;
    try {
        return (nodeChildStatus & checkStatus) === checkStatus;
    } catch (ex) {
        me.writeError("hasChildSTatus", ex);
        return "";
    }
};
vcSignalTopology.prototype.setChildStatus = function (d, status) {
    /// <summary>Adds the childStatus to the node uses an the logical "or" and the status integer</summary>
    /// <param name="d" type="Node">The node to set the childStatu</param>
    /// <param name="checkStatus" type="ENUM.CHILD_STATUS">The childstatus to add taken from the prepared enum</param>
    var me = this;
    try {
        if (d.childStatus === me.ENUM_CHILD_STATUS.NONE)
            d.childStatus = 0;
        /*jslint bitwise: true */
        d.childStatus |= status;
        return d;
    } catch (ex) {
        me.writeError("setChildSTatus", ex);
        return "";
    }
};
vcSignalTopology.prototype.removeChildStatus = function (d, status) {
    /// <summary>Removes the childstatus from the Node without affecting the others <br/>
    ///  by using the logical "and" and the contrary of the status  </summary>
    /// <param name="d" type="Node">The node to remove the childStatus</param>
    /// <param name="checkStatus" type="ENUM.CHILD_STATUS">The childstatus to remove taken from the prepared enum</param>
    /*jslint bitwise: true */
    d.childStatus &= ~status;
    return d;
};
vcSignalTopology.prototype.collapse = function (me, d) {
    try {

        if (me.hasChildStatus(d.childStatus, me.ENUM_CHILD_STATUS.SHOWN)) {
            d = me.removeChildStatus(d, me.ENUM_CHILD_STATUS.SHOWN);
            d = me.setChildStatus(d, me.ENUM_CHILD_STATUS.HIDDEN);
            d._children = d.children;
            d.children = null;
            d._children.forEach(function (x) {
                x.nodeStatus = me.ENUM_NODE_STATUS.HIDDEN;
            });
        }
        if (me.hasChildStatus(d.childStatus, me.ENUM_CHILD_STATUS.SPECIAL_SHOWN)) {
            d._specialChildren = d.specialChildren;
            d.specialChildren = null;
            d = me.removeChildStatus(d, me.ENUM_CHILD_STATUS.SPECIAL_SHOWN);
            d = me.setChildStatus(d, me.ENUM_CHILD_STATUS.SPECIAL_HIDDEN);
        }
        return d;
    } catch (ex) {
        me.writeError("collapse", ex);
        return "";
    }
};
vcSignalTopology.prototype.expand = function (me, d) {
    try {
        if (me.hasChildStatus(d.childStatus, me.ENUM_CHILD_STATUS.HIDDEN)) {
            me.removeChildStatus(d, me.ENUM_CHILD_STATUS.HIDDEN);
            me.setChildStatus(d, me.ENUM_CHILD_STATUS.SHOWN);
            d.children = d._children;
            d.children.forEach(function (x) {
                x.nodeStatus = me.ENUM_NODE_STATUS.SHOWN;
            });
            d._children = null;
        }
        if (me.hasChildStatus(d.childStatus, me.ENUM_CHILD_STATUS.SPECIAL_HIDDEN)) {
            d.specialChildren = d._specialChildren;
            d._specialChildren = null;
            me.removeChildStatus(d, me.ENUM_CHILD_STATUS.SPECIAL_HIDDEN);
            me.setChildStatus(d, me.ENUM_CHILD_STATUS.SPECIAL_SHOWN);
        }
        return d;
    } catch (ex) {
        me.writeError("expand", ex);
        return "";
    }
};
vcSignalTopology.prototype.toggleChildren = function (me, d) {
    /// <summary>Helperfunction that expands/collapses the node as needed</summary>
    /// <param name="d" type="node">the node to toggle the children for</param>
    /// <returns type="node">the same node but with children hidden/shown</returns>
    try {
        if (me.hasChildStatus(d.childStatus, me.ENUM_CHILD_STATUS.SHOWN) || me.hasChildStatus(d.childStatus, me.ENUM_CHILD_STATUS.SPECIAL_SHOWN)) {
            d = me.collapse(me, d);
        } else if (me.hasChildStatus(d.childStatus, me.ENUM_CHILD_STATUS.HIDDEN) || me.hasChildStatus(d.childStatus, me.ENUM_CHILD_STATUS.SPECIAL_HIDDEN)) {
            d = me.expand(me, d);
        }

        me.updateTree(d, false);
    } catch (ex) {
        me.writeError("toggleChildren", ex);
    }
};
vcSignalTopology.prototype.setNodeClass = function (d) {
    if (d.signalid === "-1") {
        return "node nE";
    } else {
        return "node";
    }
};
vcSignalTopology.prototype.filterRootNode = function (d) {
    return d.signalid !== -1;
};
vcSignalTopology.prototype.appendStyleElement = function (nodeEnter, me) {
    if (me === "undefined") {
        me = this;                                     
    }
    try {
        nodeEnter.append("circle").attr("r", 9).attr("class", function (d) {
            if (d.isGenerator === "True")
                return "nodeCircle circleGen";
            else
                return "nodeCircle";
        }).on('click', function (d) {
            me.toggleChildren(me, d);
        }).attr("transform","translate("+ me.nodeWidth +",0)");
    } catch (ex) {
        me.writeError("appendStyleElement", ex);
    }
};
vcSignalTopology.prototype.buildNodeIE = function(nodeEnter) {
    var me = this;
    try {
        nodeEnter.append("rect").attr("class", "nodeBox").attr("y", -25).attr("width", "380px")
            .attr("height", "50px").attr("x", function(d) {
                if (me.settings.data.OnlyFirstLevel === true) {
                    if (d.depth === 2) {
                        return me.nodeWidth + 5;

                    } else {
                        return -5;
                    }
                } else {
                    return 0;
                }
            });

        var text = nodeEnter.append("text").attr('class',
            function(d) {
                if (d.isInternal === false && d.isActive === true) {
                    return 'nodeText';
                } else {
                    return 'nodeText noClick';
                }
            }).style("fill-opacity", 1);
       
        //on("click",
        //    function (d) {
        //        if (!me.settings.data.archiveParam) {
        //            if (d.isInternal === false && d.isActive === true) {
        //                me.callSignalInfo(me, d);
        //            }
        //        }
        //    })
        text.append("tspan").text(function (d) {
            return d.name;
        }).on("mouseout mouseover",
                function () {
                    window.d3.event.stopPropagation();
                }).attr("text-anchor", function (d) {
                    if (me.settings.data.OnlyFirstLevel === true && d.depth === 2) {
                        return "start";
                    } else {
                        return "end";
                    }
            }).attr("width", "360px").attr("dx", "360").attr("dy","0").attr("class", function (d) {
                    if (d.name.length >= 40) {
                        return "spanText nodeName long";
                    } else {
                        return " spanText nodeName";
                    }
                });
        if (!me.settings.data.archiveParam) {
            nodeEnter.filter(me.filterRootNode).filter(function (d) {
                    return d.isInternal === false && d.isActive === true;
                }).append("text")
                .attr("class", "extraFont fa fa-lg nodeInfo color-fill-primary")
                .attr("style", "font-size:1.6em; paint-order: stroke; stroke: black; stroke-width:1px").text("\uf05a")
                .on("click",
                function (d) {
                    if (d.isInternal === false && d.isActive === true) {
                        me.callSignalInfo(me, d);
                    }
                }).attr("dx", "365").attr("dy", "0").attr("height", "50px");
        }
    } catch (ex) {
        me.writeError("buildNodeIE", ex);
    }
};
vcSignalTopology.prototype.buildNode = function (nodeEnter) {
    var me = this;
    try {
        if (me.ieVersion === -1 || me.ieVersion > 11) {
            me.buildNodeNotIE(nodeEnter);
        } else {
            me.buildNodeIE(nodeEnter);
        }
                me.appendStyleElement(nodeEnter, me);

    } catch (ex) {
        me.writeError("buildNode", ex);
    }

};

vcSignalTopology.prototype.buildNodeNotIE = function(nodeEnter) {
    var me = this;
    try {
        nodeEnter.append("rect").attr("class", "nodeBox").attr("y", -25).attr("width", me.nodeWidth).attr("height", 50).attr("x", function(d) {
                if (me.settings.data.OnlyFirstLevel === true && d.depth === 2) {
                    return me.nodeWidth;
                } else {
                    return 0;
                }
            });

        var obj = nodeEnter.append("foreignObject").attr("class",
            function (d) {
                if (me.settings.data.OnlyFirstLevel && me.settings.data.OnlyFirstLevel === true) {
                    if (d.depth === 2) {
                        return "nodeText firstLevel";
                    } else {
                        return "nodeText zeroLevel";
                    }
                } else {
                    return "nodeText";
                }

            }).attr("y", -25).attr("x", function (d) {
                if (me.settings.data.OnlyFirstLevel && me.settings.data.OnlyFirstLevel === true && d.depth === 2) {
                    return me.nodeWidth;
                } else {
                    return 0;
                }
            }).attr("width", me.nodeWidth + "px")
            .attr("height", "50px");

        obj.append("xhtml:div").attr("class", "nodeTextDiv").append("div").attr("class", "nodeTextContent").append("div").attr("class",
         function(d) {
                if (d.name.length >= 40) {
                    return "nodeName long";
                } else {
                    return "nodeName";
                }                                                                                                                                                       
            }).html(function(d) {
            return d.name;
        }).on("mouseout mouseover",
            function() {
                window.d3.event.stopPropagation();
            });
        if (!me.settings.data.archiveParam) {
            nodeEnter.filter(me.filterRootNode).filter(function(d) {
                    return d.isInternal === false && d.isActive === true;
                }).select(".nodeTextDiv").insert("i", ".nodeTextContent")
                .attr("class", "extraFont fa-regular fa-lg nodeInfo color-font-secondary fa-info-circle")
                .on("click",
                    function(d) {
                        if (d.isInternal === false && d.isActive === true) {
                            me.callSignalInfo(me, d);
                        }
                    });
        }
    } catch (ex) {
        me.writeError("buildNode", ex);
    }
};
vcSignalTopology.prototype.callSignalInfo = function (me, d) {
    /// <summary>ClickHandler function that calls the VisualCoreService and shows the signalinformation dialog</summary>
    /// <param name="d" type="node">the node clicked, actually needed is only the signalid</param>
    me.vcVisual.showSignalAnalogSummaryDialog(d.signalid);
   
};

vcSignalTopology.prototype.doEvent = function (event) {
    var me = this;
    try {
        switch (event.msg) {

        case 'topo_full_screen':

            break;

        case 'topo_show_help':
            me.dialog.html(me.createHelp()).dialog("option", {
                "title": me.settings.resources.help,
                "width": "auto",
                "height": "80%",
                "modal": false
            }).dialog("open").css({
                "margin-right": "1px",
                border: "solid 1px"
            });
            break;

        }
        return true;
    } catch (ex) {
        me.writeError('doEvent', ex);
        return false;
    }
};
vcSignalTopology.prototype.detectIE = function () {
    var me = this;
    try {
        var ua = window.navigator.userAgent;
        

        var msie = ua.indexOf('MSIE ');
        if (msie > 0) {
            // IE 10 or older => return version number
            return parseInt(ua.substring(msie + 5, ua.indexOf('.', msie)), 10);
        }

        var trident = ua.indexOf('Trident/');
        if (trident > 0) {
            // IE 11 => return version number
            var rv = ua.indexOf('rv:');
            return parseInt(ua.substring(rv + 3, ua.indexOf('.', rv)), 10);
        }

        var edge = ua.indexOf('Edge/');
        if (edge > 0) {
            // Edge (IE 12+) => return version number
            return parseInt(ua.substring(edge + 5, ua.indexOf('.', edge)), 10);
        }

        // other browser
        return -1;
    } catch (ex) {
        me.writeError('detectIE', ex);
        return -2;
    }
};

